/**
 * Swagger Interface
 * 数据交换格式: JSON
 *
 * OpenAPI spec version: v2.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
 * @description topicDeleteCommentTopicCommentIdUsingPut参数
 * @property `topicCommentId` 帖子评论ID
 */
export interface ParamstopicDeleteCommentTopicCommentIdUsingPut {
  // pathParams
  /**
   * 帖子评论ID
   */
  topicCommentId: string;
}
/**
 * @description topicDeleteTopicIdUsingPut参数
 * @property `topicId` 帖子ID
 */
export interface ParamstopicDeleteTopicIdUsingPut {
  // pathParams
  /**
   * 帖子ID
   */
  topicId: string;
}
/**
 * @description topicGroupIdGroupUsingGet参数
 * @property `groupId` 圈子ID
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 * @property `[type]` 最热类型/最新类型 最热->HOT 最新->LATEST
 */
export interface ParamstopicGroupIdGroupUsingGet {
  // pathParams
  /**
   * 圈子ID
   */
  groupId: string;
  // queryParams
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
  /**
   * 最热类型/最新类型 最热->HOT 最新->LATEST
   */
  type?: string;
}
/**
 * topicCommentPublishVO
 */
export type ParamsBodytopicPublishCommentUsingPost = models.TopicCommentPublishVO;
/**
 * topicPublishVO
 */
export type ParamsBodytopicPublishUsingPost = models.TopicPublishVO;
/**
 * @description topicTopicIdCommentUsingGet参数
 * @property `topicId` 帖子ID
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 */
export interface ParamstopicTopicIdCommentUsingGet {
  // pathParams
  /**
   * 帖子ID
   */
  topicId: string;
  // queryParams
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * @description topicTopicIdUsingGet参数
 * @property `topicId` 帖子ID
 */
export interface ParamstopicTopicIdUsingGet {
  // pathParams
  /**
   * 帖子ID
   */
  topicId: string;
}
export class TopicApi {
  protected $basePath = '/community/be'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   * 
   * @summary 删除帖子评论
   * @param params ParamstopicDeleteCommentTopicCommentIdUsingPut
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public topicDeleteCommentTopicCommentIdUsingPut = (
    params: ParamstopicDeleteCommentTopicCommentIdUsingPut,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/topic/delete/comment/{topicCommentId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.topicCommentId, 'topicCommentId');
    return ajax.ajax(
      {
        ...opt,
        method: 'PUT',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 删除帖子
   * @param params ParamstopicDeleteTopicIdUsingPut
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public topicDeleteTopicIdUsingPut = (
    params: ParamstopicDeleteTopicIdUsingPut,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/topic/delete/{topicId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.topicId, 'topicId');
    return ajax.ajax(
      {
        ...opt,
        method: 'PUT',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 查看帖子列表
   * @param params ParamstopicGroupIdGroupUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResulttopicInfoVO
   */
  public topicGroupIdGroupUsingGet = (
    params: ParamstopicGroupIdGroupUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResulttopicInfoVO> => {
    const path = '/api/topic/{groupId}/group';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    if ('type' in params) p.query.type = params.type;
    ajax.check(params.groupId, 'groupId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 发布评论
   
   * @param data: ParamsBodytopicPublishCommentUsingPost// topicCommentPublishVO
   * @param opt ajax config
   * @returns models.CommonResulttopicCommentInfoVO
   */
  public topicPublishCommentUsingPost = (
    data: ParamsBodytopicPublishCommentUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResulttopicCommentInfoVO> => {
    const path = '/api/topic/publish/comment';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.topicCommentPublishVO');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 发布帖子
   
   * @param data: ParamsBodytopicPublishUsingPost// topicPublishVO
   * @param opt ajax config
   * @returns models.CommonResulttopicInfoVO
   */
  public topicPublishUsingPost = (
    data: ParamsBodytopicPublishUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResulttopicInfoVO> => {
    const path = '/api/topic/publish';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.topicPublishVO');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 查看评论列表
   * @param params ParamstopicTopicIdCommentUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResulttopicCommentInfoVO
   */
  public topicTopicIdCommentUsingGet = (
    params: ParamstopicTopicIdCommentUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResulttopicCommentInfoVO> => {
    const path = '/api/topic/{topicId}/comment';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    ajax.check(params.topicId, 'topicId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 查看帖子
   * @param params ParamstopicTopicIdUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResulttopicInfoVO
   */
  public topicTopicIdUsingGet = (
    params: ParamstopicTopicIdUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResulttopicInfoVO> => {
    const path = '/api/topic/{topicId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.topicId, 'topicId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
}

export default new TopicApi();
